'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import React from 'react';
import Link from 'next/link';
import { useParams } from 'next/navigation';

function IntroText() {
  const { locale } = useParams();

  switch (locale) {
    case 'fr':
      return (
        <div className="d-flex flex-column justify-content-center align-items-center h-100">
          <div className="mw-100">
            <p>
              Vous recherchez un emploi temporaire ou permanent dans la logistique, la production, la construction, la vente,
              l'administration ou tout autre secteur ? Trouvez l'emploi de vos rêves dans votre région grâce à Synergie.
            </p>
            <p>
              Consultez l’ensemble de <Link href={`/${locale}/jobs/`}>nos postes vacants</Link> ou planifiez un entretien avec{' '}
              <Link href={`/${locale}/agencies`}>l’agence Synergie</Link> près de chez vous. A bientôt !
            </p>
          </div>
        </div>
      );

    case 'en':
    case 'pl':
    case 'ro':
      return (
        <div className="d-flex flex-column justify-content-center align-items-center h-100">
          <div className="mw-100">
            <p>
              Are you looking for a temporary or permanent job in logistics, production, construction, sales, administration or
              another job category? Find your dream job in your region at Synergie.
            </p>
            <p>
              Look in the overview with all <Link href={`/${locale}/jobs/`}>our vacancies</Link> or schedule a meeting with the{' '}
              <Link href={`/${locale}/agencies`}>Synergie office</Link> near you. See you soon!
            </p>
          </div>
        </div>
      );
    case 'nl':
    default:
      return (
        <div className="d-flex flex-column justify-content-center align-items-center h-100">
          <div className="mw-100">
            <p>
              Ben je op zoek naar een tijdelijke of vaste job in logistiek, productie, bouw, verkoop, administratie of een andere
              jobcategorie? Vind jouw droomjob in jouw regio bij Synergie.
            </p>
            <p>
              Kijk in het overzicht met al <Link href={`/${locale}/jobs/`}>onze openstaande vacatures</Link> of plan een gesprek
              in met het <Link href={`/${locale}/agencies`}>Synergie-kantoor</Link> in jouw buurt. Tot snel!
            </p>
          </div>
        </div>
      );
  }
}

export default IntroText;
